import { render, staticRenderFns } from "./CompModal.vue?vue&type=template&id=54d550f4&"
import script from "./CompModal.vue?vue&type=script&lang=js&"
export * from "./CompModal.vue?vue&type=script&lang=js&"
import style0 from "./CompModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports